<template>
  <div dir="ltr" class="related_resource" :class="{ show_divider: show_divider }">
    <div>
      <div>
        <div v-if="related_resource.id != undefined" class="is-flex is-align-items-center">
          <a @click="deleteRelatedResource" class="button is-danger is-outlined" :class="{ 'is-loading': is_deleting }">X</a>
        </div>
      </div>
      <div class="is-flex is-align-items-center">
        <link-entity :payload="related_resource[action_type].position.company"></link-entity>
        <div class="is-flex is-align-items-center border_left">
          <link-entity :payload="related_resource[action_type].position" :additional_data="{ resource_type: 'Position' }"></link-entity>
          <div class="horizontal_space"></div>
          <div class="horizontal_space"></div>
          <div style="font-size: 12px;">
            <div>
              <p class="m-0">Position Status:</p>
              <position-status :payload="related_resource[action_type].position" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div dir="rtl" class="is-flex is-justify-content-space-between" style="font-size: 12px;">
      <div class="border_left">
        <p style="margin-bottom: 0;"><b>Related Resource Message</b></p>
        <message :payload="related_resource" :additional_data="{ endpoint: '/related_resources/', headers: 'admin_headers' }">
        </message>
      </div>
      <div>
        <p style="margin-bottom: 0;"><b>Position Message</b></p>
        <message :payload="related_resource[action_type].position"
                 :additional_data="{ resource_type: 'Position', endpoint: '/positions/', headers: 'admin_headers' }">
        </message>
      </div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import Message from '@/components/Message'
import PositionStatus from '@/components/PositionStatus'
export default {
  name: 'related-resource',
  props: {
    related_resource: {},
    show_divider: {},
    action_type: {
      type: String,
      default: 'leader'
    }
  },
  data () {
    return {
      is_deleting: false
    }
  },
  methods: {
    deleteRelatedResource () {
      if (!confirm('בטוח למחוק?')) {
        return
      }
      this.is_deleting = true
      this.$network_utils.deleteRelatedResource({ id: this.related_resource.id }).then(() => {
        this.$utils.emit('show_toast', { text: 'נמחק בהצלחה' })
        this.$emit('deleted')
        this.is_deleting = false
      })
    }
  },
  components: {
    LinkEntity,
    Message,
    PositionStatus
  }
}
</script>
<style scoped>
  .border_left{
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid rgba(0, 0, 0, 0.15);
  }
  .related_resource{
    padding: 1em;
    text-align: left;
  }
  .show_divider{
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .left_container{
    display: flex;
    align-items: center;
  }
</style>
